import React from 'react';

const NotificationList = () => {
      return (
            <>
            </>
      )
}

export default NotificationList;